import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-nx-soft"><div className="animate-pulse text-gray-400">Cargando…</div></div>;
  }
  if (!user) return <Navigate to="/redaccion-nexodum/login" replace />;
  return children;
}
